export default "__VITE_ASSET__kwHwe4xf__"